import {
  appApiFormDataHeaders,
  appApiHeaders,
  getApiUrl,
} from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const POST_CREATE_SITE = 'POST_CREATE_SITE'
export const createSiteApi = apiCall(
  POST_CREATE_SITE,
  ({ ...payload }: Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites`),
    method: 'POST',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_UPDATE_SITE = 'POST_UPDATE_SITE'
export const updateSiteApi = apiCall(
  POST_UPDATE_SITE,
  ({ id, ...payload }: { id: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${id}`),
    method: 'PATCH',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_VERIFY_SITE_DOMAIN = 'POST_VERIFY_SITE_DOMAIN'
export const verifySiteDomainApi = apiCall(
  POST_VERIFY_SITE_DOMAIN,
  ({ id }: { id: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${id}/domain/verify`),
    method: 'POST',
    headers: appApiHeaders(),
  }),
)

interface UpdateSiteImagesParams {
  id: string
  logo?: File | null
  logoIcon?: File | null
  logoFavicon?: File | null
  removeLogo?: boolean
  removeLogoIcon?: boolean
  removeLogoFavicon?: boolean
}

const POST_UPDATE_SITE_IMAGES = 'POST_UPDATE_SITE_IMAGES'
export const updateSiteImagesApi = apiCall(
  POST_UPDATE_SITE_IMAGES,
  ({ id, logo, logoIcon, logoFavicon, removeLogo, removeLogoIcon, removeLogoFavicon }: UpdateSiteImagesParams) => {
    const formData = new FormData()
    if (logo instanceof File) {
      formData.append('logo', logo)
    }
    if (logoIcon instanceof File) {
      formData.append('logoIcon', logoIcon)
    }
    if (logoFavicon instanceof File) {
      formData.append('logoFavicon', logoFavicon)
    }
    if (removeLogo) {
      formData.append('removeLogo', 'true')
    }
    if (removeLogoIcon) {
      formData.append('removeLogoIcon', 'true')
    }
    if (removeLogoFavicon) {
      formData.append('removeLogoFavicon', 'true')
    }
    return {
      endpoint: getApiUrl(`/api/cms/v1/sites/${id}/settings/images`),
      method: 'POST',
      body: formData,
      headers: appApiFormDataHeaders(),
    }
  },
)

const POST_DELETE_SITE = 'POST_DELETE_SITE'
export const deleteSiteApi = apiCall(
  POST_DELETE_SITE,
  ({ id, confirmation }: { id: string; confirmation: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${id}`),
    method: 'DELETE',
    body: { confirmation },
    headers: appApiHeaders(),
  }),
)
